/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Adaptability_Flexibility23Inputs */

const en_job_form_enum_adaptability_flexibility23 = /** @type {(inputs: Job_Form_Enum_Adaptability_Flexibility23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptability and Flexibility`)
};

const de_job_form_enum_adaptability_flexibility23 = /** @type {(inputs: Job_Form_Enum_Adaptability_Flexibility23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassungsfähigkeit und Flexibilität`)
};

/**
* | output |
* | --- |
* | "Adaptability and Flexibility" |
*
* @param {Job_Form_Enum_Adaptability_Flexibility23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_adaptability_flexibility23 = /** @type {((inputs?: Job_Form_Enum_Adaptability_Flexibility23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Adaptability_Flexibility23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_adaptability_flexibility23(inputs)
	return en_job_form_enum_adaptability_flexibility23(inputs)
});
export { job_form_enum_adaptability_flexibility23 as "job_form_enum_ADAPTABILITY_FLEXIBILITY" }